// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* طباعة كشف المسافرين فقط — بدون القائمة الجانبية وواجهة النظام */
@media print {
  @page {
    margin: 10mm;
    size: A4 portrait;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    overflow: visible !important;
  }

  body:has(.manifest-print-root) > *:not(.manifest-print-root) {
    display: none !important;
  }

  .manifest-print-root {
    position: static !important;
    inset: auto !important;
    width: 100% !important;
    max-width: none !important;
    max-height: none !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    overflow: visible !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .manifest-print-root .no-print,
  .manifest-print-root .print\\:hidden {
    display: none !important;
  }

  .manifest-print-root .manifest-scroll {
    max-height: none !important;
    overflow: visible !important;
  }

  .manifest-container {
    padding: 0 !important;
    margin: 0 !important;
    box-shadow: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TripPassengerManifest/manifest-print.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;EAC7B;AACF","sourcesContent":["/* طباعة كشف المسافرين فقط — بدون القائمة الجانبية وواجهة النظام */\n@media print {\n  @page {\n    margin: 10mm;\n    size: A4 portrait;\n  }\n\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    overflow: visible !important;\n  }\n\n  body:has(.manifest-print-root) > *:not(.manifest-print-root) {\n    display: none !important;\n  }\n\n  .manifest-print-root {\n    position: static !important;\n    inset: auto !important;\n    width: 100% !important;\n    max-width: none !important;\n    max-height: none !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    overflow: visible !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n  }\n\n  .manifest-print-root .no-print,\n  .manifest-print-root .print\\:hidden {\n    display: none !important;\n  }\n\n  .manifest-print-root .manifest-scroll {\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  .manifest-container {\n    padding: 0 !important;\n    margin: 0 !important;\n    box-shadow: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
